<template>
    <div>
        <div class="login-title font-M1">
            <div style="margin: auto; width: 100px;">
                <img src="/Content/images/logo_mis.png" style="width: 100px;" />
            </div>
            <div class="media-body">
                <div class="text-center" style="padding: 8px 0; font-size: 18px;">ការផ្ទៀងផ្ទាត់សុវត្ថិភាពជំហានទី២ 💬</div>
                <div class="text-center font-KB" style="padding: 5px 0; font-size: 14px; color: #333; line-height: 24px;">
                    យើងបានផ្ញើលេខកូដផ្ទៀងផ្ទាត់ទៅកាន់ទូរស័ព្ទរបស់អ្នក។ សូមបញ្ចូលលេខកូដដែលបានផ្ញើមកពីទូរស័ព្ទ
                    នៅក្នុងប្រអប់ខាងក្រោម។
                </div>
            </div>
        </div>
        <div class="login-content" style="padding: 30px 15px;">
            <h6 class="font-KB">សូមបញ្ចូលលេខកូដសុវត្ថិភាព ៦ ខ្ទង់របស់អ្នក</h6>
            <div class="input-wrap">
                <OtpInput input-classes="otp-input"
                          separator=""
                          :num-inputs="6"
                          :should-auto-focus="true"
                          :is-input-num="true"
                          @on-complete="onVerify" />
            </div>
        </div>
        <div class="row" style="margin-bottom: 35px;">
            <div class="col-xs-12">
                <div class="text-center font-KB" style="font-size: 14px;">
                    <span class="me-1">មិនទទួលបានលេខកូដមែនទេ?</span>
                    <a href="javascript:void(0)">ផ្ញើឡើងវិញ</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import qs from 'qs';
    import axios from 'axios';
    import Swal from 'sweetalert2';
    import OtpInput from "@bachdgvn/vue-otp-input";

    export default {
        components: {
            OtpInput
        },
        props: {
            user: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                login: {},
            }
        },
        methods: {
            onVerify: function (value) {
                var loading = this.loading();
                this.login.Otp = value;
                this.login.__RequestVerificationToken = $('[name="__RequestVerificationToken"]').val();
                axios.post(path('Account/Verfiy2FA'), qs.stringify(this.login)).then(res => {
                    loading.hide();
                    const data = res.data
                    if (data.IsError) {
                        Swal.fire('Warning Message', data.ErrorMessage, 'error');
                    } else {
                        window.location = data.Json.Link;
                    }
                });
            },
            loading () {
                return this.$loading.show({
                    color: '#0856ab'
                });
            }
        },
        watch: {
            user: {
                handler(val) {
                    if (val != null) {
                        this.login = val;
                    }
                },
                immediate: true
            }
        },
    }
</script>
<style>
    .otp-input {
        width: 40px;
        height: 40px;
        padding: 5px;
        margin: 0 5px;
        font-size: 14px;
        border-radius: 4px;
        border: 1px solid #ddd;
        text-align: center;
    }
    .input-wrap div{
        justify-content: space-between;
    }
    .error {
        border: 1px solid red !important;
    }

    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>


// WEBPACK FOOTER //
// Components/Auth/2FA.vue